module.exports = __webpack_public_path__ + "static/image-01-b@2x-645b852e69e1a411ce94f47f38977e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/image-01-b@2x.jpg
// module id = 435
// module chunks = 3627797113349 20562973939449 33019919093843